export default __webpack_public_path__ + "static/media/task-line.f142516d.svg";